interface AvisoTelefonesSuporteProps {
  className?: string;
}

/** Aviso temporário exibido ao lado do botão de WhatsApp de suporte */
export function AvisoTelefonesSuporte({ className = '' }: AvisoTelefonesSuporteProps) {
  return (
    <div
      role="alert"
      className={`items-center gap-2 bg-amber-100 border border-amber-400 text-amber-900 font-semibold leading-tight ${className}`}
    >
      <span aria-hidden="true">⚠️</span>
      <span>
        Gravi Águas com problemas em todos os telefones por motivos climáticos.
        Somente o WhatsApp do botão Suporte Técnico está funcionando.
      </span>
    </div>
  );
}
